// extracted by mini-css-extract-plugin
module.exports = {"container":"WordList_container__3ZJiW","list":"WordList_list__b6W26","listItem":"WordList_listItem__3JQLh","heading":"WordList_heading__3Brvz","cancel":"WordList_cancel__7XzdW"};